/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output, OnChanges, OnDestroy, OnInit } from '@angular/core';
/**
 * Constant imports
 */
import { ACTION_ON, ACTION_TYPE, COMMUNITY_LIST_TYPE, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Service import.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * model imports
 */
import { CommunityFilter, COMMUNITY_PAGE } from '../../onboarding/interface/global.model';
import { Subject } from 'rxjs';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';


/**
 * Show the create Community Card.
 */
@Component({
  selector: 'app-create-community-card',
  templateUrl: './create-community-card.component.html',
  styleUrls: ['./create-community-card.component.scss']
})

export class CreateCommunityCardComponent implements OnInit ,OnChanges, OnDestroy {
  /**
   * Event Emitter to Emit Filter Key based on Community Type
   * Event Emitter to Emit community filter key
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitFilterKey: EventEmitter<any> = new EventEmitter();
  @Output() emitCommunityFilterKey: EventEmitter<{
    key: string,
    flag?: boolean,
    publicListView?: boolean
  }> = new EventEmitter();
  /**
   * Emits back button visibility event
   */
  @Output() emitShowBackBtn: EventEmitter<boolean> = new EventEmitter();
  /**
  * Emits page event
  */
  @Output() emitPage: EventEmitter<COMMUNITY_PAGE> = new EventEmitter();

  /**
   * Set Filter as All By Default
   * @communityListType constant for COMMUNITY_LIST_TYPE
   */
  @Input() setFilterAsAll: string;
  public setDefaultFilter = COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY;
  public communityListType = COMMUNITY_LIST_TYPE;
  /**
   * Check for Empty Screen
   */
  @Input() showNoCommunity: boolean;
  public showCommunity: boolean;

  /**
   * Receive the object for the community detail.
   */
  @Input() translations: { [key: string]: string } = {};
  /**
   * Community is past key.
   */
  @Input() isPastCommunity?: boolean;
  /**
   * Current page
   */
  @Input() currentPage: COMMUNITY_PAGE;
  /**
   * Show commnity filter
   */
  public showfilter = false;
  /**
   * Device is mobile or not
   */
  public isMobile: boolean;

  /**
   * active filters to show on currentPage
   */
  public activeFilters: CommunityFilter[];
  /**
   * Public community listing page
   */
  public publicCommunityPage = COMMUNITY_PAGE.PUBLIC_LIST;


  /**
   * numbers constant
   */
  public numbers = NUMBERS;
  /**
   * List of community all filters
   */
  private filters: CommunityFilter[] = [
    {
      id: 'all',
      checked: this.communityListType.MY_ALL_COMMUNITY,
      value: this.communityListType.MY_ALL_COMMUNITY,
      labelText: this.mls.languageText.community.key42,
      page: COMMUNITY_PAGE.COMMUNITY_LIST,
      enable: NUMBERS.ONE,
      isPastCommunity: false
    },
    {
      id: 'public-community',
      checked: this.communityListType.PUBLIC_COMMUNITY,
      value: this.communityListType.PUBLIC_COMMUNITY,
      labelText: this.mls.languageText.community.key118,
      page: COMMUNITY_PAGE.COMMUNITY_LIST,
      enable: NUMBERS.ONE,
      isPastCommunity: false
    },
    {
      id: 'my-community',
      checked: this.communityListType.MY_COMMUNITY,
      value: this.communityListType.MY_COMMUNITY,
      labelText: this.mls.languageText.community.key41,
      page: COMMUNITY_PAGE.COMMUNITY_LIST,
      enable: NUMBERS.ONE,
      isPastCommunity: false
    },
    {
      id: 'all',
      checked: this.communityListType.MY_ALL_COMMUNITY,
      value: this.communityListType.MY_ALL_COMMUNITY,
      labelText: this.mls.languageText.community.key42,
      page: COMMUNITY_PAGE.MY_COMMUNITY_LIST,
      enable: NUMBERS.ONE,
      isPastCommunity: false
    },
    {
      id: 'manage-by-me',
      checked: this.communityListType.MY_COMMUNITY,
      value: this.communityListType.MY_COMMUNITY,
      labelText: this.mls.languageText.community.key131,
      page: COMMUNITY_PAGE.MY_COMMUNITY_LIST,
      enable: NUMBERS.ONE,
      isPastCommunity: false
    },
    {
      id: 'other-community',
      checked: this.communityListType.OTHER_COMMUNITY,
      value: this.communityListType.OTHER_COMMUNITY,
      labelText: this.mls.languageText.community.key43,
      page: COMMUNITY_PAGE.MY_COMMUNITY_LIST,
      enable: NUMBERS.ONE,
      isPastCommunity: false
    },
    {
      id: 'past-community',
      checked: this.communityListType.PAST_COMMUNITY,
      value: this.communityListType.PAST_COMMUNITY,
      labelText: this.mls.languageText.community.key132,
      page: COMMUNITY_PAGE.PAST_INACTIVE_COMMUNITY,
      enable: NUMBERS.ONE,
      isPastCommunity: true
    },
    {
      id: 'inactive-community',
      checked: this.communityListType.INACTIVE_COMMUNITY,
      value: this.communityListType.INACTIVE_COMMUNITY,
      labelText: this.mls.languageText.community.key133,
      page: COMMUNITY_PAGE.PAST_INACTIVE_COMMUNITY,
      enable: NUMBERS.ONE,
      isPastCommunity: true
    }
  ];

  /**
   * notifier subject to remove data stream
   */
  private notifier$ = new Subject();

  /**
   * Necessary instances.
   */
  constructor(public mls: NewLanguageService,
    public fcs: FunCollectionService,
    private analyticSdk: Analytics,
    private dss: DataStorageService) { }

  /**
   * On Initialize
   */
  ngOnInit(): void {
    this.isMobile = this.fcs.device_detail.is_mobile;
    this.updateFilterSettings();
    this.getActiveFilters();
  }

  /**
   * method to Check Selected Community Type
  */
  onItemChange(event): void {
    const filter = event.target.value;
    switch (filter) {
      case COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY:
        if (this.currentPage === COMMUNITY_PAGE.MY_COMMUNITY_LIST) {
          this.getFilterData(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY);
        } else {
          this.setFilterData(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, true);
        }
        break;
      case COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY:
        this.getFilterData(COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY);
        break;
      case COMMUNITY_LIST_TYPE.MY_COMMUNITY:
        if (this.currentPage === COMMUNITY_PAGE.MY_COMMUNITY_LIST) {
          this.getFilterData(COMMUNITY_LIST_TYPE.MY_COMMUNITY);
        } else {
          this.getFilterData(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY);
        }
        break;
      case COMMUNITY_LIST_TYPE.OTHER_COMMUNITY:
        this.getFilterData(COMMUNITY_LIST_TYPE.OTHER_COMMUNITY);
        break;
      case COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY:
        this.setFilterData(COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY, false, true);
        break;
      case COMMUNITY_LIST_TYPE.PAST_COMMUNITY:
        this.getFilterData(COMMUNITY_LIST_TYPE.PAST_COMMUNITY);
        break;
      case COMMUNITY_LIST_TYPE.INACTIVE_COMMUNITY:
        this.getFilterData(COMMUNITY_LIST_TYPE.INACTIVE_COMMUNITY);
        break;
      default:
        this.setFilterData(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, true);
        break;
    }
    this.setCurrentPage(filter);
  }
  /**
   * method to Emit Selected Community Type to Community List Component
   * to Render Filter Based Community List
  */
  getFilterData(key): void {
    this.emitFilterKey.emit(key);
  }

  /**
   * eventhandler to emit public community
   */
  setFilterData(key: string, flag: boolean, publicListView?: boolean): void {
    this.emitCommunityFilterKey.emit({ key, flag, publicListView });
  }

  /**
   * ngOnChanges
  */
  ngOnChanges(): void {
    this.setDefaultFilter = this.setFilterAsAll ? this.setFilterAsAll : COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY;
    this.setCurrentPage(this.setDefaultFilter);
    this.showCommunity = this.showNoCommunity;
  }
  /**
   * Show filte or hide
   */
  showFilter(): void {
    this.showfilter = !this.showfilter;
  }

  /**
   * Handler to set active filter on page
   */
  getActiveFilters(): void {
    this.activeFilters = this.filters.filter(filter => [this.currentPage].indexOf(filter.page) > NUMBERS.MINUS_ONE && filter.enable === NUMBERS.ONE);
  }

  /**
   * Handler to setup current page
   * @param filter current page
   */
  setCurrentPage(filter: string): void {
    switch (filter) {
      case COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY:
        if (this.currentPage !== COMMUNITY_PAGE.MY_COMMUNITY_LIST) {
          this.currentPage = COMMUNITY_PAGE.COMMUNITY_LIST;
        }
        break;
      case COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY:
        this.currentPage = COMMUNITY_PAGE.PUBLIC_LIST;
        break;
      case COMMUNITY_LIST_TYPE.MY_COMMUNITY:
      case COMMUNITY_LIST_TYPE.OTHER_COMMUNITY:
        this.currentPage = COMMUNITY_PAGE.MY_COMMUNITY_LIST;
        break;
      case COMMUNITY_LIST_TYPE.PAST_COMMUNITY:
      case COMMUNITY_LIST_TYPE.INACTIVE_COMMUNITY:
      case COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY:
        this.currentPage = COMMUNITY_PAGE.PAST_INACTIVE_COMMUNITY;
        break;
      default:
        this.currentPage = COMMUNITY_PAGE.COMMUNITY_LIST;
    }
    this.getActiveFilters();
    this.emitPageName(this.currentPage);
  }

  /**
   * Update filters based on page
   * @param filter settings
   */
  updateFilterSettings(): void {
    if (this.isPastCommunity) {
      this.currentPage = COMMUNITY_PAGE.PAST_INACTIVE_COMMUNITY;
      this.filters[0].checked = COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY;
      this.filters[0].value = COMMUNITY_LIST_TYPE.PAST_AND_INACTIVE_COMMUNITY;
      this.filters[0].page = this.currentPage;
    } else {
      this.currentPage = COMMUNITY_PAGE.COMMUNITY_LIST;
    }
  }

  /**
   * emits backbutton status event
   * @param event back buttons
   */
  emitBackButtonStatus(event: boolean): void {
    this.emitShowBackBtn.emit(event);
  }

  /**
   * emits pagename event
   * @param pageName emit
   */
  emitPageName(pageName: COMMUNITY_PAGE): void {
    this.emitPage.emit(pageName);
  }

  /**
  * unsubscribe the subscription.
  */
  ngOnDestroy(): void {
    this.notifier$.next();
    this.notifier$.complete();
  }
  /**
   * create community
   */
  createCommunity(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, 0, this.fcs.currentScreename, CTA_TYPE.FLOATING_BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CREATE_COMMUNITY,null);
  }
  /**
   * past community navigation
   */
  pastCommunity(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, 0, this.fcs.currentScreename, CTA_TYPE.MORE_OPTION, ACTION_TYPE.CLICK, ACTION_ON.COMMUNITY_PAST_INACTIVE,null);
  }
}
